import fetch from '@/utils/fetch';
import {
  GetAreaTreeParams,
  GetDistrictListParams,
  OrderInfoParams,
  RetentionInfoParams,
  OrderTrendParams,
  CommonParams,
  OrderBusinessParams,
  RetentionTableParams,
  FetchOverviewParams,
  MerchandiseListParams,
  RegionItem,
} from './types';

// 区域搜索
export const fetchAreaTree = async (params: GetAreaTreeParams) => {
  const data = await fetch('/datahub/crm/dim/area/tree', {
    params,
  });
  return data;
};
// 区域搜索
export const fetchAreaTreeV2 = async (params: GetAreaTreeParams) => {
  const data = await fetch('/datahub/crm/dim/area/tree/v2', {
    params,
  });
  return data;
};

// 获取商圈列表
export const fetchBDList = async (params: GetDistrictListParams) => {
  const data = await fetch('/datahub/crm/dim/districtList/v3', {
    params,
  });
  return data;
};

// 订单-数据趋势
export const fetchOrderTrend = async (params: OrderTrendParams) => {
  const data = await fetch('/datahub/crm/visualization/order/trend', {
    params,
  });
  return data;
};

// 商圈查询（通过城市查询）
export const fetchBusinessDistric = async (params) => {
  const data = await fetch('/datahub/crm/dim/area/businessDistrict', {
    params,
  });
  return data;
};

// 订单-数据看板
export const fetchOrderInfo = (params: OrderInfoParams) => {
  return fetch('/datahub/crm/visualization/order/info', {
    params,
  });
};

// 订单-业务分布
export const fetchOrderBusiness = (params: OrderBusinessParams) => {
  return fetch('/datahub/crm/visualization/order/business', {
    params,
  });
};

// 订单-订单类型分布
export const fetchOrderOrderTypes = (params: OrderBusinessParams) => {
  return fetch('/datahub/crm/visualization/order/orderType', {
    params,
  });
};

// 订单-排行榜
export const fetchOrderRanks = (params: OrderBusinessParams) => {
  return fetch('/datahub/crm/visualization/order/rank', {
    params,
  });
};

// 排行榜（城市、商圈、门店、企业）
export const fetchMoreOrderRanks = (type: string, params: OrderBusinessParams) => {
  return fetch(`/datahub/crm/visualization/order/rank/${type}`, {
    params,
  });
};

// 圈长排名
export const fetchOrderRanksGroupmaster = (params: OrderBusinessParams) => {
  return fetch(`/datahub/crm/visualization/order/rank/groupmaster`, {
    params,
  });
};

// 订单-圈长订单排名
export const fetchRankGroupmaster = (params: CommonParams) => {
  return fetch('/datahub/crm/visualization/order/rank/groupmaster', {
    params,
  });
};

// 用户-数据看板
export const fetchUserInfo = (params: RetentionInfoParams) => {
  return fetch('/datahub/crm/visualization/user/info', {
    params,
  });
};

// 用户-用户留存数据
export const fetchRetentionInfo = (params: RetentionInfoParams) => {
  return fetch('/datahub/crm/visualization/user/retention/info', {
    params,
  });
};

// 用户-企业认证用户排行
export const fetchRankEnterprise = (params: RetentionInfoParams) => {
  return fetch('/datahub/crm/visualization/user/rank/enterprise', {
    params,
  });
};

// 用户-饭圈用户排行
export const fetchUserRankGroupmaster = (params: RetentionInfoParams) => {
  return fetch('/datahub/crm/visualization/user/rank/groupmaster', {
    params,
  });
};

// 用户-用户访问漏斗
export const fetchUserAccessfunnel = (params: RetentionInfoParams) => {
  return fetch('/datahub/crm/visualization/user/accessfunnel', {
    params,
  });
};

// 用户-日留存数据
export const fetchUserRetentionDay = (params: RetentionTableParams) => {
  return fetch('/datahub/crm/visualization/user/retention/day', {
    params,
  });
};

// 用户-月留存数据
export const fetchUserRetentionMonth = (params: RetentionTableParams) => {
  return fetch('/datahub/crm/visualization/user/retention/month', {
    params,
  });
};
/** 查看当前用户权限 */
export const userDataList = async () => {
  const data = await fetch('/datahub/crm/user/authData');
  if (data && data.tipStatus === 1) {
    const powerNameArr: string[] = [];
    Object.keys(data).forEach((key) => {
      if (key !== 'superUser' && key !== 'tipStatus') {
        if (key === 'bigRegionList') {
          if (data[key] && data[key].length > 0) {
            data[key].forEach((item) => {
              powerNameArr.push(item);
            });
          }
        } else if (key === 'businessDistrictList') {
          if (data[key] && data[key].length > 0) {
            data[key].forEach((item) => {
              powerNameArr.push(item);
            });
          }
        } else if (data[key] !== null) {
          powerNameArr.push(...data[key]);
        }
      }
    });
    let lastPowerNameArr = powerNameArr;
    if (powerNameArr && powerNameArr.length > 6) {
      lastPowerNameArr = powerNameArr.slice(0, 6);
      return `${lastPowerNameArr.join('、')}等`;
    }
    return lastPowerNameArr.join('、');
  }
  return '';
};

/**
 * 查看数据面板
 */
export const fetchOverview = (params: FetchOverviewParams) => {
  return fetch('/datahub/crm/merchandise/overview', {
    params,
  });
};

/**
 * 查看商品排行列表
 */
export const fetchMerchandiseList = async (params: MerchandiseListParams) => {
  const data = await fetch('/datahub/crm/merchandise/list', {
    params,
  });
  return data;
};

/** 商户列表 */
export const fetchShopList = (params: { id: string }) =>
  fetch<RegionItem[]>('/datahub/crm/dim/shopList/v2', { params });

/** 门店列表 */
export const fetchSubShopList = (params: { id: string }) =>
  fetch<RegionItem[]>('/datahub/crm/dim/subShopList/v2', { params });

/** 企业列表 */
export const fetchCompanyList = (params: { id: string }) =>
  fetch<RegionItem[]>('/datahub/crm/dim/companyList/v2', { params });
